import React from 'react';
const headerImage = 'https://cdn.magicpatterns.com/uploads/huxVQgLzNSCNxkhzZg4adV/if-header-1920_x1080.jpg';
export function Header() {
  return <header className="relative h-[500px] w-full overflow-hidden bg-[#01052a]" data-id="element-69" data-mp="2dogx6lcpnt9f">
      <img src={headerImage} alt="" fetchPriority="high" decoding="async" className="absolute inset-0 h-full w-full object-cover object-center" data-id="element-70" data-mp="2ijw9h8v2lh3q" />
      <div className="absolute inset-0 bg-black/30" data-id="element-71" data-mp="2rldzbiya4x5m" />
      <div className="container relative z-10 mx-auto h-full px-4" data-id="element-72" data-mp="2wkyxhr5ml1ha">
        <div className="absolute right-0 top-1/4 flex w-full -translate-y-1/2 flex-col items-end pr-4 md:w-5/12 md:pr-8 lg:w-5/12" data-id="element-73" data-mp="2wj5ow6bgc76n">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pkbawTE5HWWk594wDkbqhh/if_logo.png" alt="Improbability Foundation" decoding="async" className="h-auto w-full max-w-[350px]" data-id="element-74" data-mp="36as74mm7j6iw" />
          <p className="mt-6 text-right text-sm italic text-white md:text-base" data-id="element-75" data-mp="3fc9ixssl0m1s">
            Inspiring the Quest for the
            <br data-id="element-76" data-mp="2wihwnumxm4io" />
            Highly Improbable
          </p>
        </div>
      </div>
    </header>;
}